var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorWeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#B8C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8203 6.50577V23.5464L44.726 29.6379L30.8203 6.50577Z",
    fill: "#091825"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9068 6.51282V23.5464L16.1938 29.553L29.9068 6.51282Z",
    fill: "#091825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9069 24.5437V39.0506L15.7373 30.7506L29.9069 24.5437Z",
    fill: "#091825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8203 39.051V24.5437L44.9999 30.7548L30.8203 39.051Z",
    fill: "#091825"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9071 53.6369V41.9687L15.8328 33.7283L29.9071 53.6369Z",
    fill: "#091825"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8946 33.7283L30.8203 53.6369V41.9687L44.8946 33.7283Z",
    fill: "#091825"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorWeth);
export default __webpack_public_path__ + "static/media/COLOR-WETH.587d0ffc0590ffaea0934f2c2d60a57c.svg";
export { ForwardRef as ReactComponent };